export class CaseCompletionDto {
  "personalMessage": string;

  constructor(data: any) {
    this.personalMessage = data.personalMessage;
  }
}
